// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Hjbd","col":"styles_col___zUWN","fulfillmentStatus":"styles_fulfillmentStatus__1TDsV","emailCol":"styles_emailCol__2VZWk"};